import { selectFromUserInviteDto } from '../../models';

export default selectFromUserInviteDto()
  .uuid
  .email
  .invitingUser(u => u.fullname)
  .organization(o => o.name)
  .role(r => r.name)
  .expiresOn
  .toString();
